<template>
    <div class="container">
        <PatientsListingFilters :filters="params" :order-options="['oldest', 'newest']" @change="onFilters" />

        <div class="matrix-panel">
            <div class="table-layout table-patient">
                <TableHeader v-if="patients.length !== 0" />

                <PatientsListingTableBody
                    ref="TableBody"
                    :params="params"
                    :phase="phase"
                    @fetched="onFetched"
                >
                    <PatientRow v-for="patient in patients" :key="patient.id" :patient="patient" />
                </PatientsListingTableBody>
            </div>
        </div>
    </div>
</template>

<script>
import PatientRow from '@components/CoachAdmin/PatientsMatrix/InApp/PatientRow'
import TableHeader from '@components/CoachAdmin/PatientsMatrix/InApp/TableHeader'

import PatientsListing from '@components/PatientsMatrix/PatientsMatrix'

export default {
    components: {
        PatientRow,
        TableHeader
    },
    extends: PatientsListing,
    mounted() {
        $(function() {
            $('.item-patient').addClass('active')
        })
    }
}
</script>
